import api from '../../../../api'

export const FETCH_EXPENSE_HISTORY_PENDING = 'FETCH_EXPENSE_HISTORY_PENDING'
export const FETCH_EXPENSE_HISTORY_FULFILLED = 'FETCH_EXPENSE_HISTORY_FULFILLED'
export const FETCH_EXPENSE_HISTORY_REJECTED = 'FETCH_EXPENSE_HISTORY_REJECTED'

export const DELETE_EXPENSE_HISTORY_PENDING = 'DELETE_EXPENSE_HISTORY_PENDING'
export const DELETE_EXPENSE_HISTORY_FULFILLED = 'DELETE_EXPENSE_HISTORY_FULFILLED'
export const DELETE_EXPENSE_HISTORY_REJECTED = 'DELETE_EXPENSE_HISTORY_REJECTED'

export const CHANGE_EXPENSE_HISTORY = 'CHANGE_EXPENSE_HISTORY'

export function changeExpenseHistory(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_EXPENSE_HISTORY, payload: { name, value } })
  }
}

export function findAllExpenseHistorys(filter) {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_EXPENSE_HISTORY_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllExpenseHistorys {
                  despesasPorPeriodo (input: {
                    matriz: ${filter.matriz}
                    dataHoraInicial: "${filter.dataHoraInicial}"
                    dataHoraFinal: "${filter.dataHoraFinal}"
                  }) {
                    codigo
                    numeroNota
                    dataEmissao
                    dataVencimento
                    fornecedor
                    odometro
                    veiculo
                    motorista
                    descricao
                    valorTotal
                    veiculoDespesa {
                      placa
                      descricao
                    }
                    fornecedorDespesa {
                      razaoSocial
                    }
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { despesasPorPeriodo } = data
        dispatch({ type: FETCH_EXPENSE_HISTORY_FULFILLED, payload: despesasPorPeriodo });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, error });
      reject(error);
    });

  });

}

export function findAllVehicleExpenseHistorys(filter) {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_EXPENSE_HISTORY_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllVehicleExpenseHistorys {
                  despesasVeiculoPorPeriodo (input: {
                    veiculo: ${filter.veiculo}
                    dataHoraInicial: "${filter.dataHoraInicial}"
                    dataHoraFinal: "${filter.dataHoraFinal}"
                  }) {
                    codigo
                    numeroNota
                    dataEmissao
                    dataVencimento
                    fornecedor
                    odometro
                    veiculo
                    motorista
                    descricao
                    valorTotal
                    veiculoDespesa {
                      placa
                      descricao
                    }
                    fornecedorDespesa {
                      razaoSocial
                    }
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { despesasVeiculoPorPeriodo } = data
        dispatch({ type: FETCH_EXPENSE_HISTORY_FULFILLED, payload: despesasVeiculoPorPeriodo });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, error });
      reject(error);
    });

  });

}

export function findAllProviderExpenseHistorys(filter) {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_EXPENSE_HISTORY_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllProviderExpenseHistorys {
                  despesasFornecedorPorPeriodo (input: {
                    fornecedor: ${filter.fornecedor}
                    dataHoraInicial: "${filter.dataHoraInicial}"
                    dataHoraFinal: "${filter.dataHoraFinal}"
                  }) {
                    codigo
                    numeroNota
                    dataEmissao
                    dataVencimento
                    fornecedor
                    odometro
                    veiculo
                    motorista
                    descricao
                    valorTotal
                    veiculoDespesa {
                      placa
                      descricao
                    }
                    fornecedorDespesa {
                      razaoSocial
                    }
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { despesasFornecedorPorPeriodo } = data
        dispatch({ type: FETCH_EXPENSE_HISTORY_FULFILLED, payload: despesasFornecedorPorPeriodo });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_EXPENSE_HISTORY_REJECTED, error });
      reject(error);
    });

  });

}
